import { render } from "./Footer.vue?vue&type=template&id=2f2d0a6a&lang=pug"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=2f2d0a6a&lang=sass"

import exportComponent from "/home/runner/work/valeriya-artist/valeriya-artist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__